export default {
    'FalsterGroteskLight': {
        fontFamily: 'BC-Falster-Grotesk-Light',
        fontWeight: 'normal',
        fontStyle: 'normal',
    },
    'FalsterGroteskLightItalic': {
        fontFamily: 'BC-Falster-Grotesk-Light-Italic',
        fontWeight: 'normal',
        fontStyle: 'normal',
    },
};


// WEBPACK FOOTER //
// ./src/constants/fonts.ts